export default "__VITE_ASSET__DPdsvdlj__"